import { render, staticRenderFns } from "./affiliation.vue?vue&type=template&id=6d12d8ee&scoped=true"
import script from "./affiliation.vue?vue&type=script&lang=js"
export * from "./affiliation.vue?vue&type=script&lang=js"
import style0 from "./affiliation.vue?vue&type=style&index=0&id=6d12d8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d12d8ee",
  null
  
)

export default component.exports